import React, { useState } from 'react';

interface DeletionChecklistProps {
  onContinue: () => void;
  onCancel: () => void;
}

const DeletionChecklist: React.FC<DeletionChecklistProps> = ({ onContinue, onCancel }) => {
  const [checkedItems, setCheckedItems] = useState<Set<string>>(new Set());

  const checklistItems = [
    { id: 'understand-delete', text: 'I understand this will permanently delete my XETA account' },
    {
      id: 'understand-config',
      text: 'I understand all my WiFi router configurations will be lost',
    },
    {
      id: 'understand-access',
      text: 'I understand I will lose access to XETA services immediately',
    },
    { id: 'understand-irreversible', text: 'I understand this action cannot be reversed' },
    { id: 'saved-data', text: 'I have saved any important configuration data I want to keep' },
  ];

  const handleCheckChange = (itemId: string) => {
    const newCheckedItems = new Set(checkedItems);
    if (newCheckedItems.has(itemId)) {
      newCheckedItems.delete(itemId);
    } else {
      newCheckedItems.add(itemId);
    }
    setCheckedItems(newCheckedItems);
  };

  const allItemsChecked = checkedItems.size === checklistItems.length;

  return (
    <div className="deletion-checklist">
      <h2>Before we proceed, please confirm you understand the following:</h2>
      <div className="checklist">
        {checklistItems.map((item) => (
          <label key={item.id} className="checklist-item">
            <input
              type="checkbox"
              checked={checkedItems.has(item.id)}
              onChange={() => handleCheckChange(item.id)}
            />
            <span>{item.text}</span>
          </label>
        ))}
      </div>
      <div className="additional-info">
        <details>
          <summary>What data will be deleted vs. retained?</summary>
          <div className="data-details">
            <h4>Data to be deleted:</h4>
            <ul>
              <li>User account information (name, email, contact details)</li>
              <li>WiFi router configurations and network settings</li>
              <li>Device information and network topology data</li>
              <li>User preferences and settings</li>
              <li>Access logs and usage analytics tied to the user</li>
            </ul>
            <h4>Data to be retained:</h4>
            <ul>
              <li>Accounting records required for tax and business compliance</li>
              <li>Anonymized or aggregated data that cannot be linked to the individual</li>
              <li>Legal hold data (if applicable)</li>
            </ul>
          </div>
        </details>
        <p className="timeline-info">
          <strong>Timeline:</strong> Your deletion request will typically be processed within 30
          days.
        </p>
      </div>
      <div className="button-group">
        <button onClick={onCancel} className="cancel-button">
          Cancel
        </button>
        <button onClick={onContinue} disabled={!allItemsChecked} className="continue-button">
          Continue
        </button>
      </div>
    </div>
  );
};

export default DeletionChecklist;
